import { client } from './client';
import { CustomFieldViewModel, CreateOrUpdateCustomFieldViewModel } from '../models/configuration';

// ===== Custom Fields =====

export const getAllCustomFields = async (): Promise<CustomFieldViewModel[]> => {
  const { data } = await client.get<CustomFieldViewModel[]>('/configuration/custom-field');
  return data;
};

export const getCustomField = async (id: number): Promise<CustomFieldViewModel> => {
  const { data } = await client.get<CustomFieldViewModel>(`/configuration/custom-field/${id}`);
  return data;
};

export const createCustomField = async (payload: CreateOrUpdateCustomFieldViewModel): Promise<CustomFieldViewModel> => {
  const { data } = await client.post<CustomFieldViewModel>('/configuration/custom-field', payload);
  return data;
};

export const updateCustomField = async (id: number, payload: CreateOrUpdateCustomFieldViewModel): Promise<CustomFieldViewModel> => {
  const { data } = await client.put<CustomFieldViewModel>(`/configuration/custom-field/${id}`, payload);
  return data;
};

export const deleteCustomField = async (id: number): Promise<void> => {
  await client.delete(`/configuration/custom-field/${id}`);
};

